<template>
  <VContainer class="social pa-0">
    <a
      v-new-tab="$t('a11y.link.opensInNewTab')"
      :href="$t('footer.urlFacebook')"
      rel="noreferrer"
      target="_blank"
    >
      <img
        alt="facebook"
        src="~/assets/images/icons/social/SU_FACEBOOK_CIRCLE.svg"
        class="logo-img"
        data-testid="icon-facebook"
      >
    </a>
    <a
      v-new-tab="$t('a11y.link.opensInNewTab')"
      :href="$t('footer.urlInstagram')"
      rel="noreferrer"
      target="_blank"
    >
      <img
        alt="instagram"
        src="~/assets/images/icons/social/SU_INSTAGRAM_CIRCLE.svg"
        data-testid="icon-instagram"
      >
    </a>
    <a
      v-new-tab="$t('a11y.link.opensInNewTab')"
      :href="$t('footer.urlPinterest')"
      rel="noreferrer"
      target="_blank"
    >
      <img
        alt="pinterest"
        src="~/assets/images/icons/social/SU_PINTEREST_CIRCLE.svg"
        data-testid="icon-pinterest"
      >
    </a>
    <a
      v-new-tab="$t('a11y.link.opensInNewTab')"
      :href="$t('footer.urlYoutube')"
      rel="noreferrer"
      target="_blank"
    >
      <img
        alt="youtube"
        src="~/assets/images/icons/social/SU_YOUTUBE_CIRCLE.svg"
        data-testid="icon-youtube"
      >
    </a>
  </VContainer>
</template>

<script setup lang="ts">
</script>

<style lang="scss" scoped>
  .social img {
    height: 35px;
    width: 40px;
  }
</style>
